import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GamificationCardsService } from '../../../services/gamification-cards.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-curator-list-dialog',
  standalone: true,
  imports: [MatDialogModule,MatProgressSpinnerModule, CommonModule, MatButtonModule, FormsModule, NgMultiSelectDropDownModule, MatCardModule, MatTableModule, MatSelectModule, MatInputModule, MatFormFieldModule, MatPaginatorModule, MatSortModule, MatDividerModule, MatTooltipModule],
  templateUrl: './curator-list-dialog.component.html',
  styleUrl: './curator-list-dialog.component.scss'
})
export class CuratorListDialogComponent {

  displayedColumns: string[] = [
    'rank',
    'curator_name',
    'category',
    'reviewed',
    'approved',
    'rejected'
  ];
  sort_order: string = 'desc';
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator = {} as MatPaginator;
  totalRecords: any = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 20];
  pageNumbers: number[] = [];
  curatorListData: any;
  searchtextData: string = '';
  search_text: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  reviewedAscSort: boolean = true;
  reviewedDesSort: boolean = false;
  sort_by: string = '';
  currentPage = 0;
  isLoading:boolean=false;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly dialogRef: MatDialogRef<CuratorListDialogComponent>,
      private readonly gamificationService: GamificationCardsService,
      private readonly dialog: MatDialog,
    ){
  
    }

    ngOnInit() {
      this.getCuratorList();
    }


    getCuratorList() {
      this.isLoading=true;
      let categories = this.data?.categories;
      let subcategories = this.data?.subcategories
      const params: any = {
        start_date: this.data?.start_date,
        end_date: this.data?.end_date,
        search_text: this.search_text,
        offset: (this.pageSize * this.pageIndex),
        limit: this.pageSize,
        sort_order: this.sort_order,
        count: false
      }
      const payload: any = {
        categories,
        subcategories
      }
      this.gamificationService.getCuratorList(params,payload).subscribe({
        next: (resp:any) => {
        this.isLoading=false;
        this.curatorListData = resp?.data?.data;
        this.dataSource.data = this.curatorListData.map((item: any, index: number) => ({
          ...item,
        }));
 
        this.totalRecords = resp?.data?.total;
        const totalPages = Math.ceil(this.totalRecords / this.pageSize);
        this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i);
      },error: (error:any) => {
        this.isLoading=false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }}
    )
    }

    onPageChange(event: any) {
     
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.currentPage = event.pageIndex;
      this.getCuratorList();
    }

    onPageChangeFromDropdown(event: any) {
     
      this.pageIndex = event.value;
      this.currentPage = this.pageIndex;
      this.getCuratorList();
    }

    onSearchChange() {
      if (this.searchtextData == '') {
        this.search_text = this.searchtextData;
        this.getCuratorList();
      }
    }

    searchData(data:any) {
      if(data == '') {
        return
      } else {
        this.search_text = data;
        this.pageIndex = 0;
        this.getCuratorList();
      }
    }

    clearSearch() {
      if (this.searchInput) {
        this.searchtextData = '';
        this.search_text = '';
        this.pageIndex = 0;
        this.getCuratorList();
      }
    }

    sortingByAsc(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'reviewed') {
        this.reviewedAscSort = false;
        this.reviewedDesSort = true;
        this.sort_order = 'asc';
        this.getCuratorList();
      }
    }

    sortingByDes(sortColumn:any) {
      this.pageIndex = 0;
      if (sortColumn == 'reviewed') {
        this.reviewedDesSort = false;
        this.reviewedAscSort = true;
        this.sort_order = 'desc';
        this.getCuratorList();
      }
    }

    closeDialog() {
      this.dialogRef.close();
    }

    openSnackbar(message: string, title: string, cssClass: string) {
        this.dialog.open(ErrorNotficationComponent, {
          data: {
            message: message,
            title: title,
            action_type: 'add',
            cssClass: cssClass,
          },
        });
      }
}
